var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCustomers = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.02v-.207c1.446-.553 2.5-2.275 2.5-4.313C14.5 4.015 12.933 2 11 2S7.5 4.015 7.5 6.5c0 2.038 1.054 3.76 2.5 4.313v.207c-3.392.139-6 .972-6 1.98v2h14v-2c0-1.008-2.608-1.841-6-1.98"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7.009V6.93c1.141-.324 2-1.737 2-3.43C20 1.567 18.881 0 17.5 0S15 1.567 15 3.5c0 1.693.859 3.106 2 3.43v.079c-.497.018-.97.064-1.404.131-.098 1.066-.439 2.051-.965 2.859H22v-1.5c0-.772-1.75-1.408-4-1.491zM6.404 7.141A12 12 0 0 0 5 7.01v-.079c1.141-.324 2-1.737 2-3.43 0-1.933-1.119-3.5-2.5-3.5S2 1.568 2 3.501c0 1.693.859 3.106 2 3.43v.079c-2.25.083-4 .719-4 1.491v1.5h7.369c-.526-.809-.867-1.794-.965-2.859z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCustomers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/customers.svg";